module.exports = __webpack_public_path__ + "static/media/wrong_answer.d39e1eeb.svg";